import { useEffect, useRef } from 'react'

const useEffectOnce = (effect: React.EffectCallback) => {
  const didRun = useRef(false)

  useEffect(() => {
    if (!didRun.current) {
      didRun.current = true
      return effect()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export default useEffectOnce
